import { useRouter } from "next/router";

import { useAppStore } from "@/global/store";
import { purchaseSeatsTabUIDs } from "@/global/config/constants";
import { calcPerksSubtotal, calcTicketSubtotal } from "@/global/utils/utils";
import { selectCartManager } from "@/global/store/data/purchaseSeats/cartManager";

// prettier-ignore
export function useFrontendSubtotals() {
  const router = useRouter();
  const purchaseSeatTab = router.query.purchaseSeatTab as string;
  const shouldSumPerksPrice = purchaseSeatTab === purchaseSeatsTabUIDs.chooseSeats;
  const shouldSumOrderServiceFee = purchaseSeatTab === purchaseSeatsTabUIDs.checkout;

  const cartState = useAppStore(selectCartManager);
  const ticketSubtotal = calcTicketSubtotal(cartState, shouldSumPerksPrice, shouldSumOrderServiceFee);
  const perksSubtotal = calcPerksSubtotal(cartState.cart);

  return {
    ticketSubtotal,
    perksSubtotal,
  };
}
